import { render, staticRenderFns } from "./DumbappSharing.vue?vue&type=template&id=15d63d32&scoped=true&"
import script from "./DumbappSharing.vue?vue&type=script&lang=ts&"
export * from "./DumbappSharing.vue?vue&type=script&lang=ts&"
import style0 from "./DumbappSharing.vue?vue&type=style&index=0&id=15d63d32&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d63d32",
  null
  
)

export default component.exports